
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/what-is-machine-learning",
      function () {
        return require("private-next-pages/what-is-machine-learning/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/what-is-machine-learning"])
      });
    }
  